<div class="product-trio-details">
  <div class="details-header">
    <h4 class="details-title">Aportación del product-trio</h4>
    <div class="details-summary">
      <span class="summary-pill total"
        >{{ totalNewTasks() }} tarea{{ totalNewTasks() === 1 ? '' : 's' }} nueva{{ totalNewTasks() === 1 ? '' : 's' }}</span
      >
      @if (trioCoveragePrcnt() !== null) {
        <span
          class="summary-pill trio"
          [matTooltip]="trioCreatedTasksCount() + '/' + totalNewTasks() + ' creadas por el trío'"
          matTooltipPosition="above"
        >
          Trío: {{ trioCoveragePrcnt() | number: '1.0-0' }}%
        </span>
      }
    </div>
  </div>

  @if (totalNewTasks() === 0) {
    <p class="no-data">No se han creado tareas en este periodo.</p>
  } @else if (roles().length === 0) {
    <p class="no-data">No hay datos del product-trio para este periodo.</p>
  } @else {
    <div class="roles-list">
      @for (role of roles(); track role.role_slug) {
        <div class="role-card" [class.unassigned]="!role.has_assigned_member">
          <div class="role-card-header">
            <div class="role-identity">
              <span class="role-icon-wrapper" [style.background-color]="role.status_color">
                <mat-icon class="role-icon">{{ role.icon }}</mat-icon>
              </span>
              <div class="role-text">
                <span class="role-label">{{ role.role_label }}</span>
                @if (!role.has_assigned_member) {
                  <span class="role-users muted">Sin asignar</span>
                } @else {
                  <div class="role-users-list">
                    @for (user of role.users; track user.id) {
                      <div class="role-user">
                        <img
                          class="role-user-avatar"
                          [src]="user.profile_picture_url"
                          [alt]="user.full_name"
                          onerror="this.src='assets/img/default_profile_picture.png'"
                        />
                        <span class="role-user-name">{{ user.full_name }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="role-metrics">
              @if (role.created_tasks_prcnt !== null) {
                <span class="role-prcnt" [style.color]="role.status_color">{{ role.created_tasks_prcnt | number: '1.0-1' }}%</span>
              } @else {
                <span class="role-prcnt muted">—</span>
              }
              <span class="role-count">{{ role.created_tasks_count }} / {{ totalNewTasks() }} tareas</span>
            </div>
          </div>

          <div class="role-progress">
            <div class="progress-track">
              <div class="progress-fill" [style.width.%]="role.fill_width_prcnt" [style.background-color]="role.status_color"></div>
            </div>
            <span class="role-status-pill" [style.color]="role.status_color" [style.border-color]="role.status_color">
              {{ role.status_label }}
            </span>
          </div>
        </div>
      }
    </div>
  }
</div>
